import { Entity } from '@backstage/catalog-model';

/**
 * Tab layout for the categorized /docs home (DocsHomePage).
 *
 * The "Professional Services" tab (kind: 'ps') shows the PS navigation tiles
 * from professional_services_documentation_hierarchy.md — category tiles that
 * drill into links out to existing Confluence and Google Drive content.
 *
 * Entity tabs are keyed off entity kind so new docs-bearing entities land in
 * the right tab automatically; the final "All Documentation" tab is the
 * catch-all safety net so nothing silently disappears from the index.
 * Conventions: docs/DOCS.md.
 */
export type DocsHomeTab =
  | {
      kind: 'ps';
      label: string;
      description: string;
    }
  | {
      kind: 'entities';
      label: string;
      description: string;
      filter: (entity: Entity) => boolean;
    };

export const docsHomeTabs: DocsHomeTab[] = [
  {
    kind: 'ps',
    label: 'Professional Services',
    description:
      'Professional Services documentation on Confluence and Google Drive — training, workshops, how-to guides, and onboarding.',
  },
  {
    kind: 'entities',
    label: 'Portal & Operations',
    description:
      'Running, deploying, and extending the portal — local development, permissions, template playbook, infrastructure runbooks.',
    filter: entity => entity.kind === 'Component',
  },
  {
    kind: 'entities',
    label: 'Template Guides',
    description:
      'What each template provisions — read before filling out the form.',
    filter: entity => entity.kind === 'Template',
  },
  {
    kind: 'entities',
    label: 'All Documentation',
    description: 'Every documented entity in the catalog.',
    filter: () => true,
  },
];
